import React, { useContext } from 'react';

import { usePipelineBuilder } from '../../utils/hooks/use_pipeline_interactions';
import useWorkspaceContext from '../workspaces/WorkspaceContext/WorkspaceContext';

const PipelineCreationContext = React.createContext({
  pipelineName: null,
  pipelineSteps: null,
  addStep: () => {},
  removeStep: () => {},
  build: () => {},
  setPipelineName: () => {},
});

export const PipelineCreationProvider = ({
  children, 
  pipelineToCopy, 
  pipelineStepsToCopy, 
  pipelineRefetch,
}) => {
  const { currentWorkspaceId } = useWorkspaceContext();
  const contextValues = usePipelineBuilder(currentWorkspaceId, pipelineToCopy, pipelineStepsToCopy, pipelineRefetch);
  return (
    <PipelineCreationContext.Provider
      value={contextValues}
    >
      {children}
    </PipelineCreationContext.Provider>
  )
}

export const usePipelineCreationContext = () => useContext(PipelineCreationContext);

export default usePipelineCreationContext;
